'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DisplayValueBoolean(props) {
  const {
    value
  } = props;
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: value ? 'customerDataFilters.DisplayValue.booleanTrue' : 'customerDataFilters.DisplayValue.booleanFalse'
  });
}
DisplayValueBoolean.propTypes = {
  value: PropTypes.bool.isRequired
};